"use strict";
/**
 * This code was GENERATED using the solita package.
 * Please DO NOT EDIT THIS FILE, instead rerun solita to update it or write a wrapper to add functionality.
 *
 * See: https://github.com/metaplex-foundation/solita
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.referrerFeeLogBeet = exports.ReferrerFeeLog = void 0;
const web3 = __importStar(require("@solana/web3.js"));
const beet = __importStar(require("@metaplex-foundation/beet"));
const beetSolana = __importStar(require("@metaplex-foundation/beet-solana"));
/**
 * Holds the data for the {@link ReferrerFeeLog} Account and provides de/serialization
 * functionality for that data
 *
 * @category Accounts
 * @category generated
 */
class ReferrerFeeLog {
    market;
    user;
    mint;
    referrerTokenAccount;
    referrerFee;
    constructor(market, user, mint, referrerTokenAccount, referrerFee) {
        this.market = market;
        this.user = user;
        this.mint = mint;
        this.referrerTokenAccount = referrerTokenAccount;
        this.referrerFee = referrerFee;
    }
    /**
     * Creates a {@link ReferrerFeeLog} instance from the provided args.
     */
    static fromArgs(args) {
        return new ReferrerFeeLog(args.market, args.user, args.mint, args.referrerTokenAccount, args.referrerFee);
    }
    /**
     * Deserializes the {@link ReferrerFeeLog} from the data of the provided {@link web3.AccountInfo}.
     * @returns a tuple of the account data and the offset up to which the buffer was read to obtain it.
     */
    static fromAccountInfo(accountInfo, offset = 0) {
        return ReferrerFeeLog.deserialize(accountInfo.data, offset);
    }
    /**
     * Retrieves the account info from the provided address and deserializes
     * the {@link ReferrerFeeLog} from its data.
     *
     * @throws Error if no account info is found at the address or if deserialization fails
     */
    static async fromAccountAddress(connection, address, commitmentOrConfig) {
        const accountInfo = await connection.getAccountInfo(address, commitmentOrConfig);
        if (accountInfo == null) {
            throw new Error(`Unable to find ReferrerFeeLog account at ${address}`);
        }
        return ReferrerFeeLog.fromAccountInfo(accountInfo, 0)[0];
    }
    /**
     * Provides a {@link web3.Connection.getProgramAccounts} config builder,
     * to fetch accounts matching filters that can be specified via that builder.
     *
     * @param programId - the program that owns the accounts we are filtering
     */
    static gpaBuilder(programId = new web3.PublicKey('UMnFStVeG1ecZFc2gc5K3vFy3sMpotq8C91mXBQDGwh')) {
        return beetSolana.GpaBuilder.fromStruct(programId, exports.referrerFeeLogBeet);
    }
    /**
     * Deserializes the {@link ReferrerFeeLog} from the provided data Buffer.
     * @returns a tuple of the account data and the offset up to which the buffer was read to obtain it.
     */
    static deserialize(buf, offset = 0) {
        return exports.referrerFeeLogBeet.deserialize(buf, offset);
    }
    /**
     * Serializes the {@link ReferrerFeeLog} into a Buffer.
     * @returns a tuple of the created Buffer and the offset up to which the buffer was written to store it.
     */
    serialize() {
        return exports.referrerFeeLogBeet.serialize(this);
    }
    /**
     * Returns the byteSize of a {@link Buffer} holding the serialized data of
     * {@link ReferrerFeeLog}
     */
    static get byteSize() {
        return exports.referrerFeeLogBeet.byteSize;
    }
    /**
     * Fetches the minimum balance needed to exempt an account holding
     * {@link ReferrerFeeLog} data from rent
     *
     * @param connection used to retrieve the rent exemption information
     */
    static async getMinimumBalanceForRentExemption(connection, commitment) {
        return connection.getMinimumBalanceForRentExemption(ReferrerFeeLog.byteSize, commitment);
    }
    /**
     * Determines if the provided {@link Buffer} has the correct byte size to
     * hold {@link ReferrerFeeLog} data.
     */
    static hasCorrectByteSize(buf, offset = 0) {
        return buf.byteLength - offset === ReferrerFeeLog.byteSize;
    }
    /**
     * Returns a readable version of {@link ReferrerFeeLog} properties
     * and can be used to convert to JSON and/or logging
     */
    pretty() {
        return {
            market: this.market.toBase58(),
            user: this.user.toBase58(),
            mint: this.mint.toBase58(),
            referrerTokenAccount: this.referrerTokenAccount.toBase58(),
            referrerFee: (() => {
                const x = this.referrerFee;
                if (typeof x.toNumber === 'function') {
                    try {
                        return x.toNumber();
                    }
                    catch (_) {
                        return x;
                    }
                }
                return x;
            })(),
        };
    }
}
exports.ReferrerFeeLog = ReferrerFeeLog;
/**
 * @category Accounts
 * @category generated
 */
exports.referrerFeeLogBeet = new beet.BeetStruct([
    ['market', beetSolana.publicKey],
    ['user', beetSolana.publicKey],
    ['mint', beetSolana.publicKey],
    ['referrerTokenAccount', beetSolana.publicKey],
    ['referrerFee', beet.u64],
], ReferrerFeeLog.fromArgs, 'ReferrerFeeLog');
